function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 7.667c0 .304-.115.609-.342.84l-.1.103a1.136 1.136 0 01-1.638 0l-2.762-2.845v15.546c0 .656-.52 1.189-1.159 1.189-.64 0-1.159-.533-1.159-1.19V5.766L8.078 8.61a1.137 1.137 0 01-1.639 0l-.1-.102a1.213 1.213 0 010-1.682l4.84-4.977a1.138 1.138 0 011.64 0l4.84 4.977c.226.233.341.537.341.841z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgArrowUpinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgArrowUpinline;